import { CmsTypeSlugs, TCmsTypeSlug } from '@daymade/common-lib/dbConstants';
import { CmsDocumentStatus } from '@daymade/common-lib/dbEnums';
import {
  CmsTypeSlugToZDocumentData,
  TReviewDocumentData,
  TWinnerDocumentData,
  TWinnerPolaroidDocumentData,
} from '@daymade/common-lib/dbJsonModels';
import { ensureSubsetOfKeys } from '@daymade/common-lib/types';
import { z } from 'zod';
import { zodSelectCmsDocument } from '../generated/zodSchemas.generated';

export const ZCmsDocumentStatus = z.nativeEnum(CmsDocumentStatus);

export const ZCmsDocumentSelect = zodSelectCmsDocument.extend(
  ensureSubsetOfKeys(zodSelectCmsDocument.shape, {
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    sortOrder: z.number().int(),
  }),
);
export type TCmsDocumentSelect = z.infer<typeof ZCmsDocumentSelect>;

export const ZCmsTypeSlug = z.enum(CmsTypeSlugs);

export const getZCmsDocumentSelectForTypeSlug = (typeSlug: TCmsTypeSlug) =>
  ZCmsDocumentSelect.extend({
    typeSlug: z.literal(typeSlug),
    data: CmsTypeSlugToZDocumentData[typeSlug],
  });

export type TCmsDocument = TCmsDocumentSelect;
export type TWinnerData = TWinnerDocumentData;
export type TWinnerPolaroidData = TWinnerPolaroidDocumentData;
export type TReviewData = TReviewDocumentData;
